import React, { useState, useEffect } from "react";
import { Select, Form, Row, Col, Spin } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import Idame from "../Idame/Idame";
import UniDropAdv from "../UniDrop/UniDropAdv";
import { LoadingOutlined } from "@ant-design/icons";

function TypSubTypeDynamic({
    includeAllTyp,
    includeAllSubTyp,
    colSpan,
    form,
    auxParams,
    labelCol,
    typName,
    typLabel,
    typPname,
    subTypPname,
    typRequired,
    typErrorMessage,
    typPlaceholder,
    subTypName,
    subTypLabel,
    subTypRequired,
    subTypErrorMessage,
    subTypPlaceholder,
    disabled,
    typSearchable,
    extraData,
    subTypDisabled,
    typDisabled,
    typMultiSelect,
    subTypMultiSelect,
    typDefault,
    subTypDefault,
    subTypSearchable
}) {
    const [subTypeUrlData, setSubTypeUrlData] = useState(
        auxParams['subTypSourceParams'] || {}
    )
    const [loginError, setLoginError] = useState(false);
    const [subTypLoading, setSubTypLoading] = useState(true);
    const [type, setType] = useState([]);
    const [subTypData, setSubTypData] = useState();
    const [subType, setSubType] = useState([]);
    const [dict, setDict] = useState({});
    const [selectedTypSubTyp, setSelectedTypSubTyp] = useState();
    const [mdictType, setMdictType] = useState();

    const onChangeMdictType = (value) => {
        setSubTypLoading(true);
        setMdictType(value);
        if (!typMultiSelect) {
            setSubTypeUrlData({ ...subTypeUrlData, selected: value });
            let selectedTyp = type.find(x => x.value === value);
            form.setFieldsValue({ [`${typPname}`]: selectedTyp?.label, [subTypName]: null, [subTypPname]: null });
        } else {
            setSubTypeUrlData({ ...subTypeUrlData, selected: JSON.stringify(value) });
            let typ_p_default = [];
            value.forEach(y => {
                let selectedTyp = type.find(x => x.value === y);
                typ_p_default.push(selectedTyp?.label);
            });
            form.setFieldsValue({ [`${typPname}`]: typ_p_default, [subTypName]: null, [subTypPname]: null });
        }
        setTimeout(() => {
            setSubTypLoading(false);
        }, 500);

    }

    const cacheData = (key, value) => {
        let __key = `cache_dropdown_${key}`;
        localStorage.setItem(__key, JSON.stringify(value));
    };

    const getCacheData = (key) => {
        let __key = `cache_dropdown_${key}`;
        let data = localStorage.getItem(__key);
        if (data) {
            return JSON.parse(data);
        } else {
            return null;
        }
    };

    const setTypeData = (typData) => {
        let typ = [];
        Object.keys(typData).forEach(x => {
            typ.push({ label: typData[x], value: x });
        });
        if (includeAllTyp) {
            typ.unshift({ label: 'All', value: 'all' });
        };
        setType(typ);
    }

    useEffect(() => {
        // if(auxParams['typSource'] !== 'dynamic'){
        //     let __typData = getCacheData(typName);
        //     if(__typData){
        //         setTypeData(__typData);
        //         return;
        //     }
        // }
        let typ = [];
        liracrypt
            .get(auxParams['typSource'], auxParams['typSourceParams'] || {})
            .then((res, req) => {
                let typData = res.data.data;
                if (auxParams['typSource'] !== 'dynamic') {
                    cacheData(typName, typData);
                };
                setTypeData(typData);
                if (typDefault) {
                    setTimeout(() => {
                        form.setFieldsValue({ [`${typName}`]: typDefault });
                        onChangeMdictType(typDefault);
                    }, 500);
                }
                // Object.keys(typData).forEach(x => {
                //     typ.push({ label: typData[x], value: x });
                // });
                // if (includeAllTyp) {
                //     typ.unshift({ label: 'All', value: 'all' });
                // };
                // setType(typ);
            })
            .catch((err) => {
                console.log(err);
                if (err.response !== undefined) {
                    if (err.response.status !== 401) {
                        ApiErrorComp(err.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    }, []);


    const IdameRef = subTypLoading ? <div className="loader"><Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} />} /></div> : (
        <>
            {mdictType ? (
                <Col span={24} style={{ padding: 0 }}>
                    <UniDropAdv
                        labelCol={labelCol ? labelCol : 8}
                        bg="transparent"
                        form={form}
                        multiSelect={subTypMultiSelect}
                        url={auxParams['subTypSource']}
                        disabled={subTypDisabled}
                        source={'dynamic'}
                        options={undefined}
                        extraData={extraData}
                        urlData={subTypeUrlData ? subTypeUrlData : {}}
                        pname={subTypPname ? subTypPname : `p${subTypName}`}
                        name={subTypName}
                        label={subTypLabel}
                        errorMessage={subTypErrorMessage}
                        required={subTypRequired}
                        placeholder={subTypPlaceholder}
                        defaultValue={subTypDefault}
                        includeAll={includeAllSubTyp ? includeAllSubTyp : false}
                        searchable={subTypSearchable ? subTypSearchable : true}
                    />
                </Col>
                // <Idame
                //     includeAll={includeAllSubTyp}
                //     style={{ padding: 0 }}
                //     fetchFromCache={false}
                //     width={100}
                //     idMultiSelect={subTypMultiSelect}
                //     nameMultiSelect={subTypMultiSelect}
                //     form={form}
                //     type="name"
                //     labelCol={labelCol}
                //     nameName={subTypPname}
                //     nameLabel={subTypLabel}
                //     url={auxParams['subTypSource']}
                //     urlData={subTypeUrlData}
                //     idName={subTypName}
                //     idLabel={subTypLabel}
                //     idErrorMessage={subTypErrorMessage}
                //     idRequired={subTypRequired}
                //     idPlaceholder={subTypPlaceholder}
                // />
            ) : (
                <></>
            )}
        </>
    );


    return (
        <>
            <SessionError visible={loginError} />
            <div>
                <Form.Item
                    name={typPname}
                    style={{ display: 'none' }}
                ></Form.Item>
            </div>
            <Form.Item
                name={typName}
                labelCol={{ span: labelCol ? labelCol : 8 }}
                label={typLabel}
                style={{ marginRight: "10px", fontWeight: 600 }}
                rules={[
                    {
                        required: typRequired,
                        message: typErrorMessage,
                    },
                ]}
            >
                <Select
                    onChange={onChangeMdictType}
                    showSearch={typSearchable}
                    mode={typMultiSelect ? "multiple" : undefined}
                    placeholder={typPlaceholder}
                    disabled={typDisabled}
                    style={{ fontWeight: 600 }}
                >
                    {type.map((item, index) => {
                        return (
                            <Select.Option
                                value={item.value}
                                key={index}
                                style={{ fontWeight: 600 }}
                            >
                                {item.label}
                            </Select.Option>
                        );
                    })}
                </Select>
            </Form.Item>
            {IdameRef}
            {/* <Form.Item
                name={subTypName}
                label={subTypLabel}
                style={{ marginRight: "10px", fontWeight: 600 }}
                rules={[
                    {
                        required: subTypRequired,
                        message: subTypErrorMessage,
                    },
                ]}
            >
                <Select
                    style={{ fontWeight: 600 }}
                    showSearch={true}
                    disabled={disabled}
                    placeholder={subTypPlaceholder}
                >
                    {subType.map((item, index) => {
                        return (
                            <Select.Option
                                style={{ fontWeight: 600 }}
                                value={item.value}
                                key={index}
                            >
                                {item.label}
                            </Select.Option>
                        );
                    })}
                </Select>
            </Form.Item> */}
        </>
    );
}

export default TypSubTypeDynamic;
